import ContentBlock from "../../components/UI/ContentBlock"
import ContentCard from "../../components/UI/ContentCard"
import {useEffect} from "react"
import {Button} from "antd"
import CustomerReview from "../../components/CustomerReview"
import {useNavigate} from "react-router-dom"
import {Tile, Tiles} from "../../components/UI/Tiles"
import MobileAppHeader from "./components/MobileAppHeader"

const MobileAppScreen = () => {
	const navigate = useNavigate()

	useEffect(() => {
		document.title = 'АТС24 — Мобильное приложение для водителя'
	}, [])

	return (
		<>
			<ContentBlock>
				<MobileAppHeader/>
			</ContentBlock>

			<ContentBlock background="#E9FAFF">
				<ContentCard title="Электронное задание">
					<p className="description">
						С первого взгляда водитель понимает объем задач, которые ему предстоит выполнить. На всех
						экранах его сопровождают полезная информация по маршруту, подсказки и удобная навигация.
					</p>
				</ContentCard>
			</ContentBlock>

			<ContentBlock background="#E9FAFF" top={0}>
				<ContentCard
					title="Список маршрутов" size="small"
					media={{
						url: "/assets/img/jpg/mobile-app/routes.jpg"
					}}
				>
					<p>
						Все задания удобно распределены по дням и содержат информацию о времени старта, расстоянии,
						продолжительности и объёме работы.
					</p>
				</ContentCard>

				<ContentCard
					title="Интерактивная карта" size="small" reverse
					media={{
						url: "/assets/img/jpg/mobile-app/map.jpg"
					}}
				>
					<p>
						Карта комбинируется со списком, который можно настроить по высоте.
					</p>
					<p>
						Прямо на карте отображаются маршрут, названия точек и окна приёмок.
					</p>
				</ContentCard>

				<ContentCard
					title="У клиента" size="small"
					media={{
						url: "/assets/img/jpg/mobile-app/point.jpg"
					}}
				>
					<p>
						Всего три кнопки, которые никогда не поставят водителя в тупик.
					</p>
					<ul>
						<li>Удобная панель статусов</li>
						<li>Переход в навигатор</li>
						<li>Звонок клиенту</li>
						<li>Список накладных</li>
						<li>Оценки и комментарии</li>
					</ul>
				</ContentCard>

				<ContentCard
					title="Электронные накладные" size="small" reverse
					media={{
						url: "/assets/img/jpg/mobile-app/invoices.jpg"
					}}
				>
					<p>
						Полный перечень товаров для сдачи или приёмки. Если что-то не было сдано, водитель может
						отметить позицию и указать причину, чтобы логистика сразу узнала об этом.
					</p>
				</ContentCard>
			</ContentBlock>

			<ContentBlock>
				<CustomerReview
					author="Антон Патрашов, руководитель логистики"
					description="Лучшее мобильное приложение на рынке. Минимум ресурсов на обучение и поддержку водителей"
					media={{
						url: "/assets/img/png/mobile-app/logo-cheremushki.png"
					}}
				/>
			</ContentBlock>

			{/*<ContentBlock bottom={0} background="#FFF2DF">
				<ContentCard title="Интересные решения">
					<p>
						Несколько примеров, как мобильное приложение ежедневно помогает водителю.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock top={0} background="#FFF2DF">
				<InterestingSolutionsSwiper/>
			</ContentBlock>*/}
			<ContentBlock background="#f5f5f5" gap={2}>
				<ContentCard title="Интересные функции">
					<p className="description">
						Ежедневно мы улучшаем и наращиваем функционал приложения для водителя.
					</p>
				</ContentCard>
				<Tiles>
					<Tile>
						<img src="/assets/img/jpg/mobile-app/fix.jpg"/>
						<h3>Фиксированный порядок</h3>
						<p style={{fontSize: '1rem'}}>
							Вы можете зафиксировать порядок точек, и в этом случае водитель не сможет выполнять их в
							произвольном порядке.
						</p>
					</Tile>
					<Tile>
						<img src="/assets/img/jpg/mobile-app/radius.jpg"/>
						<h3>Отметка в радиусе</h3>
						<p style={{fontSize: '1rem'}}>
							Настройте точки, которые могут быть завершены только при физическом присутствии водителя по
							адресу.
						</p>
					</Tile>
					<Tile>
						<img
							src="/assets/img/jpg/mobile-app/photo.jpg"/>
						<h3>Прикрепить фото</h3>
						<p style={{fontSize: '1rem'}}>
							Есть возможность прикрепить фото к любому заказу для подтверждения различных фактов.
						</p>
					</Tile>
					<Tile>
						<img
							src="/assets/img/jpg/mobile-app/optimization.jpg"/>
						<h3>Оптимизация маршрута</h3>
						<p style={{fontSize: '1rem'}}>
							В любой момент водитель может оптимизировать маршрут для оставшихся точек, если что-то пошло
							не по плану.
						</p>
					</Tile>
					<Tile>
						<img
							src="/assets/img/jpg/mobile-app/discard.jpg"/>
						<h3>Причины отказа</h3>
						<p style={{fontSize: '1rem'}}>
							Вы можете добавить причины отказов, которые водитель будет выбирать при отмене маршрутных
							листов, точек или вычерках.
						</p>
					</Tile>
					<Tile>
						<img
							src="/assets/img/jpg/mobile-app/invoice-sign.jpg"/>
						<h3>Электронная подпись</h3>
						<p style={{fontSize: '1rem'}}>
							В приложении можно легко отметить вычерки и получить электронную подпись клиента.
						</p>
					</Tile>
				</Tiles>
			</ContentBlock>

			<ContentBlock background="#F3FFE3">
				<ContentCard title="Атоматические статусы" size="small"
							 media={{
								 url: "/assets/img/jpg/mobile-app/automount.jpg"
							 }}
				>
					<p>
						Если водитель едет по знакомому маршруту, он может включить функцию автоматических статусов, и
						приложение будет самостоятельно фиксировать посещения точек без его участия.
					</p>
				</ContentCard>

				<ContentCard
					reverse
					title="Свой порядок объезда" size="small"
					media={{
						url: "/assets/img/jpg/mobile-app/order-points.jpg"
					}}
				>
					<p>
						Перед рейсом водитель может изучить маршрут и при необходимости составить свой собственный план
						объезда точек.
					</p>
					<p>
						Кроме того, можно сохранить порядок объезда, применять его автоматически в будущем и делиться им
						с другими водителями.
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock>
				<Tiles>
					<Tile>
						<img
							src="/assets/img/jpg/mobile-app/location-correct.jpg"/>
						<h3>Выбор точной локации</h3>
						<p style={{fontSize: '1rem'}}>
							Водитель может задать точные координаты подъезда к клиенту, и после проверки они будут
							доступны для других водителей.
						</p>
					</Tile>
					<Tile>
						<img
							src="/assets/img/jpg/mobile-app/time-correct.jpg"/>
						<h3>Неверное время приёмки</h3>
						<p style={{fontSize: '1rem'}}>
							Через приложение можно сообщить о фактическом времени приёмки, если в вашей базе время
							устарело.
						</p>
					</Tile>
				</Tiles>
			</ContentBlock>


			<ContentBlock background="#f4ebff">
				<ContentCard title="Календарь поездок" size="small"
							 media={{
								 url: "/assets/img/jpg/mobile-app/calendar.jpg"
							 }}
				>
					<p>
						Водителю всегда доступен архив маршрутных листов за любой день с информацией об адресах, пробеге
						и времени работы.
					</p>
				</ContentCard>
				<ContentCard reverse title="Штрафы ГИБДД" size="small"
							 media={{
								 url: "/assets/img/jpg/mobile-app/fines.jpg"
							 }}
				>
					<p>
						Мы автоматически получаем штрафы из ГИБДД и сразу привязываем их к водителю, который нарушил.
					</p>
					<p>
						При подключении системы мотивации мы можем удерживать сумму штрафа со счёта водителя.
					</p>
					<p>
						<Button color="default" variant="solid" size="large"
								onClick={() => navigate('/services/reports')}>
							Подробней о мотивации водителей
						</Button>
					</p>
				</ContentCard>
			</ContentBlock>
			<ContentBlock background="#000000" bottom={0}>
				<ContentCard title="Тёмная тема" textColor="#FFFFFF"
							 media={{
								 url: "/assets/img/jpg/mobile-app/night-theme.jpg"
							 }}
				>
					<p>
						Мы заботимся о здоровье водителей, поэтому в приложении есть тёмная тема, которая автоматически
						включается в вечернее время.
					</p>
				</ContentCard>
			</ContentBlock>
		</>
	)
}

export default MobileAppScreen